const INITIAL_STATE = {
  data: null,
  error: null,
  loading: false,
};
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "REQUEST_SEARCH":
      return { ...state, loading: true };
    case "SEARCH":
      return { ...state, data: action.payload, loading: false };

    case "SEARCH_FAIL":
      return { ...state, error: action.payload, loading: false };

    default:
      return state;
  }
};
